const mapStyle = [
  {
    'stylers': [{ 'saturation': '-100' }],
  },
];

export default class ModGoogleMap {
  constructor(el, googleMapKey, locationData) {
    this.$el = $(el);
    this.locationData = locationData;

    this.dom = {
      mapContainer: this.$el.find('.js-load-map')[0],
    };

    this.classes = {
      hidden: 'hidden',
      active: 'active',
    };
  }

  init() {
    this.loadGoogleMapsScript(this.initMap.bind(this));
  }

  loadGoogleMapsScript(callback) {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${window.googleKey}&loading=async&callback=initMap`;
    script.async = true;
    window.initMap = callback;
    // eslint-disable-next-line no-undef
    try {
      if (window.dataLocation && window.dataLocation.trim() !== '') {
        this.locationData = JSON.parse(window.dataLocation);
      } else {
        // Default location (you can change these coordinates)
        this.locationData = {
          lat: 40.7128,
          lng: -74.0060,
          zoom: 13
        };
      }
    } catch (e) {
      // Fallback to default location
      this.locationData = {
        lat: 40.7128,
        lng: -74.0060,
        zoom: 13
      };
    }
    document.head.appendChild(script);
  }

  initMap() {
    const mapOptions = {
      center: { lat: this.locationData.lat, lng: this.locationData.lng },
      zoom: this.locationData.zoom,
      styles: mapStyle,
    };

    // eslint-disable-next-line no-undef
    const map = new google.maps.Map(document.querySelector('.js-load-map'), mapOptions);

    // Create marker options
    const markerOptions = {
      position: { lat: this.locationData.lat, lng: this.locationData.lng },
      map,
    };

    // Use custom pin graphic if available, otherwise use default label
    if (window.pinGraphic && window.pinGraphic.trim() !== '') {
      markerOptions.icon = {
        url: window.pinGraphic,
        scaledSize: new google.maps.Size(82, 82), // Adjust size as needed
        anchor: new google.maps.Point(82, 61), // Anchor point (almost-middle right of icon)
      };
    } else {
      markerOptions.label = {
        text: 'LevLane',
        color: '#0fdcbe',
        fontWeight: 'bold',
        fontSize: '16px',
        className: 'map-marker-label',
      };
    }

    // eslint-disable-next-line no-undef
    new google.maps.Marker(markerOptions);
  }
}


$('.mod-google-map').each((_index, el) => new ModGoogleMap(el).init());
